import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import {productsService} from "../../../services/settings-services";


const initialState = {
    productsArray: [],
    productsFiltered: [],
    isLoading: false,
    error: null,
    trigger: 0,
    searchQuery: '', // Store the current search query
    queryParams: {
        sortBy: 'updatedAt',
        sortDirection: 'desc',
    },
}


const getAllProducts = createAsyncThunk(
    'productsSlice/getAllProducts',
    async (_, {getState, rejectWithValue}) => {
        try {
            const { products } = getState();
            return  await productsService.getAllProducts(products.queryParams);
        } catch (e) {
            return rejectWithValue(e.response?.data?.message || "Something went wrong");
        }
    }
);

const productsSlice = createSlice({
    name: "productsSlice",
    initialState,
    reducers: {
        changeTrigger: (state, action) => {
            state.trigger = state.trigger + 1;
        },
        setProductsQueryParams: (state, action) => {
            const nextParams = action.payload || {};
            state.queryParams = {
                ...state.queryParams,
                ...nextParams,
            };
        },
        filteredProducts: (state, action) => {
            const name = action.payload?.toLowerCase();
            state.searchQuery = name || ''; // Store the search query
            if (name) {
                state.productsFiltered = state.productsArray.filter((obj) =>
                    obj.name?.en?.toLowerCase().includes(name) ||
                    obj.name?.ru?.toLowerCase().includes(name) ||
                    obj.name?.ge?.toLowerCase().includes(name)
                );
            } else {
                state.productsFiltered = [];
            }
        },
    },
    extraReducers: builder =>
        builder
            .addCase(getAllProducts.pending, state => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllProducts.fulfilled, (state, action) => {
                state.isLoading = false;
                state.productsArray = action.payload;
                // Re-apply search filter if a search query exists
                if (state.searchQuery) {
                    const name = state.searchQuery.toLowerCase();
                    state.productsFiltered = state.productsArray.filter((obj) =>
                        obj.name?.en?.toLowerCase().includes(name) ||
                        obj.name?.ru?.toLowerCase().includes(name) ||
                        obj.name?.ge?.toLowerCase().includes(name)
                    );
                }
            })
            .addCase(getAllProducts.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
});

const {reducer: productsReducer, actions} = productsSlice;
const productsActions = {
    ...actions,
    getAllProducts
}
export {
    productsReducer,
    productsActions
}